const menu = [
	{ name: "about", path: "/" },
	{ name: "projects", path: "/projects" },
];

export default menu;